import { Button as ButtonBootstrap, Fade as FadeBootstrap } from "react-bootstrap";
import styled from "styled-components";

export const SectionContainer = styled.div`
    display: flex;
    flex-direction: column !important;
    padding: 24px;
    align-items: flex-start;
    gap: 32px;
    align-self: stretch;
    border-radius: 8px;
    background: var(--white);
    box-shadow: 0 8px 24px 0 rgba(0, 0, 0, 0.08);

    .section-border {
        border: 1px solid var(--border);
    }

    @media (max-width: 768px) {
        gap: 16px;
    }
`

export const SectionLabel = styled(ButtonBootstrap)`
    background-color: transparent !important;
    color: var(--primary) !important;
    padding: 0 !important;
    border: 0 !important;
    font-size: 18px;
    font-weight: 700;
    line-height: 140%;
    display: inline-flex !important;
    flex-direction: row !important;
    align-items: center;
    gap: 8px;

    & > .btn-label,
    & > span,
    & > div {
        display: inline-flex !important;
        flex-direction: row !important;
        align-items: center;
        gap: 8px;
    }

    &:hover,
    &:focus,
    &:active,
    &:focus-visible {
        background-color: transparent !important;
        color: var(--primary) !important;
    }

    svg {
        width: 10px;
        height: 10px;
        flex-shrink: 0;
    }
`;

export const Fade = styled(FadeBootstrap)`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 32px;
    align-self: stretch;

    @media (max-width: 768px) {
        gap: 16px;
    }
`

export const SectionHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
`;

export const ActionButton = styled.button`
    display: flex;
    width: 16px;
    height: 16px;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    border: 1px solid var(--primary);
    background: transparent;
    color: var(--primary);
    cursor: pointer;
    padding: 0;
    
    svg {
        width: 10px;
        height: 10px;
    }

    &:after {
        display: none !important;
    }
`;

